import { render, staticRenderFns } from "./RideitPassengers.vue?vue&type=template&id=1f2b9402&scoped=true"
import script from "./RideitPassengers.vue?vue&type=script&lang=ts"
export * from "./RideitPassengers.vue?vue&type=script&lang=ts"
import style0 from "./RideitPassengers.vue?vue&type=style&index=0&id=1f2b9402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b9402",
  null
  
)

export default component.exports